module.exports = __webpack_public_path__ + "fdccdaeadc154f539555bf9c9e967d62.png";